import { changedDocumentService } from '../services';
import { formDocumentChanged } from '@formbird/services';
import { DocumentChangedInfo } from '@formbird/types';

const anyWindow: any = window;
    if (!anyWindow.FormbirdServiceInjector.componentFunctions) {
      anyWindow.FormbirdServiceInjector.componentFunctions = {};
    }

    anyWindow.FormbirdServiceInjector.componentFunctions.scStaticValue = {
      process(componentDefinition, document) {
        if (document && componentDefinition?.name) {
          document[componentDefinition.name] = componentDefinition.value;

          const documentChangedInfo: DocumentChangedInfo = {
            documentId: document.documentId,
            fieldName: componentDefinition.name,
            newValue: componentDefinition.value,
            isInitValue: true
          };
          
          changedDocumentService.dispatchAction(formDocumentChanged(documentChangedInfo));
        }
    }
}